import { FormularioService } from 'src/app/services/formulario.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeMessage, ActionMessage } from 'src/app/entity/enum/enum-notification';
import { NotificationService } from 'src/app/services/notification.service';
import { FormDto } from '../../../model/form-dto';
import { FormuleFormDto } from '../../../model/formule-form-dto';
import { FormFormuleService } from '../../../service/form-formule.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { SimpleModalComponent } from 'src/app/shared/simple-modal/simple-modal.component';

@Component({
  selector: 'app-new-formule-form',
  templateUrl: './new-formule-form.component.html',
  styleUrls: ['./new-formule-form.component.scss']
})
export class NewFormuleFormComponent implements OnInit {

  form: FormGroup;
  formDTO: FormDto = new FormDto();
  isFront: boolean = false;
  isTrigger: boolean = false;
  isEdit: boolean = false;
  listTypeFormule: any[] = [];
  formuleDTO: FormuleFormDto = new FormuleFormDto();

  constructor(
    private fb: FormBuilder,
    private service: FormFormuleService,
    private notificationService: NotificationService,
    protected formularioService: FormularioService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.createForm();
    this.getFormule();
    this.populateListTypeFormule();
  }

  getForm = async () => {
    this.formDTO.id = Number(this.route.snapshot.params['form']);
    let get = await this.service.getById(this.formDTO.id);
    this.formDTO = get[0];
  }

  createForm = () => {
    this.form = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      description: ['', Validators.required],
      idForm: [null],
      isFront: [false],
      isTrigger: [false]
    })
  }

  getFormule = () => {
    let id = this.route.snapshot.params['id'];
    if (id !== undefined) {
      this.isEdit = true;
      this.service.getByIdFormule(id)
        .then(async res => {
          let form = await this.service.getById(res[0].system_form);
          this.formDTO = form[0];
          this.populateForm(res[0]);
        })
        .catch(err => {
          console.error(err);
        })
    } else {
      this.getForm();
    }
  }

  populateForm = (formule: FormuleFormDto) => {

    this.formuleDTO = formule;

    this.form.controls.id.setValue(formule.id);
    this.form.controls.name.setValue(formule.name);
    this.form.controls.idForm.setValue(formule.system_form);
    this.form.controls.isFront.setValue(formule.is_front);
    this.form.controls.isTrigger.setValue(formule.is_trigger);

    let isFront = this.listTypeFormule.find(a => a.id === 1);
    isFront.checked = formule.is_front;

    let isTrigger = this.listTypeFormule.find(a => a.id === 2);
    isTrigger.checked = formule.is_trigger;
  }

  chooseType = (id) => {
    if (id === 1) this.form.controls.isFront.setValue(this.isFront = !this.isFront);
    else this.form.controls.isTrigger.setValue(this.isTrigger = !this.isTrigger);
  }

  backList = () => {
    if (!this.isEdit) this.router.navigateByUrl('adm/form/list');
    else this.backListFormule();
  }

  backListFormule = () => {
    this.router.navigateByUrl('adm/form/formule/' + this.formDTO.id);
  }

  populateDTO = (): FormuleFormDto => {
    let obj = new FormuleFormDto();

    obj.id = this.form.controls.id.value;
    obj.name = this.form.controls.name.value;
    obj.description = this.form.controls.description.value;
    obj.is_front = this.form.controls.isFront.value;
    obj.is_trigger = this.form.controls.isTrigger.value;
    obj.system_form = this.formDTO.id;
    obj.updated_at = moment(new Date()).format('YYYY-MM-DD');

    return obj;
  }

  saveOrEdit = () => {
    if (this.isEdit) this.edit()
    else this.save();
  }

  edit = () => {
    if (this.form.invalid) {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Info
      );
      return;
    }

    this.service.saveOrUpdateFormule(this.populateDTO())
      .then(res => {
        this.backListFormule();
        this.notificationService.sendNotification(
          null,
          TypeMessage.Edit,
          ActionMessage.Success
        );
      })
      .catch(err => {
        console.error(err);
      })
  }

  save = () => {
    if (this.form.invalid) {
      this.notificationService.sendNotification(
        null,
        TypeMessage.FormInvalid,
        ActionMessage.Info
      );
      return;
    }

    this.service.saveOrUpdateFormule(this.populateDTO())
      .then(res => {
        this.addAnotherFormule();
        this.notificationService.sendNotification(
          null,
          TypeMessage.New,
          ActionMessage.Success
        );
      })
      .catch(err => {
        console.error(err);
      })

  }

  populateListTypeFormule = () => {
    this.listTypeFormule.push({ id: 1, name: 'Front', checked: false });
    this.listTypeFormule.push({ id: 2, name: 'Trigger', checked: false });
  }

  getUser = async () => {
    await this.service.getUserCwid()
      .then(res => {
        if (res.length === 0) {
          this.formularioService.userIsAdmin().subscribe(adm => {
            if (!adm) {
              this.formularioService.userIsManager().subscribe(manager => {
                if (!manager) this.backList();
              })
            }
          })
        }


      })
      .catch(err => {
        console.error(err);
      })


  }

  addAnotherFormule = () => {
    const dialogRef = this.dialog.open(SimpleModalComponent, {
      data: {
        title: 'Fórmula Cadastrada com sucesso',
        mensage: 'Deseja cadastrar outra Fórmula?',
        titleBtn1: 'Não',
        titleBtn2: 'Sim',
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.form.reset();
        this.isFront = false;
        this.isTrigger = false;
      } else this.backListFormule();
    });
  }

}
